import requestAction from '../../utils/requestAction'

export const fetchComplaintMessages = (complaintId: string) =>
  requestAction('COMPLAINT_MESSAGE')(`complaints/message/${complaintId}`, 'GET')